import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'm13.428 10.088-5 3.483a.492.492 0 0 1-.061.03c-.022.013-.043.022-.066.033a.739.739 0 0 1-.3.072H8a.745.745 0 0 1-.306-.075c-.013-.006-.028 0-.04-.01s-.029-.022-.045-.032-.025-.01-.037-.018l-5-3.483a.75.75 0 1 1 .857-1.23l3.839 2.675.1-7.395-2.011 2.008a.5.5 0 0 1-.707 0 .5.5 0 0 1 0-.707l3-3a.5.5 0 0 1 .707 0l3 3a.5.5 0 1 1-.707.707L8.635 4.133l.115 7.387 3.821-2.662a.75.75 0 1 1 .857 1.23Z';
const draw24px =
  'M20.953,15.883l-8.209,5.422a1.389,1.389,0,0,1-1.488,0L3.047,15.883a.908.908,0,0,1-.2-1.421,1.362,1.362,0,0,1,1.691-.171L11.1,18.624V4.979L8.035,7.525a1.028,1.028,0,0,1-1.278-.006.678.678,0,0,1,.007-1.074L11.389,2.6a1.03,1.03,0,0,1,1.274,0l4.576,3.847a.677.677,0,0,1,0,1.074,1.027,1.027,0,0,1-1.278,0L12.9,4.952V18.624l6.562-4.333a1.362,1.362,0,0,1,1.691.171A.908.908,0,0,1,20.953,15.883Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ZoomIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'zoom'),
) as IconWithRender;

ZoomIcon.displayName = 'ZoomIcon';
ZoomIcon.propTypes = Icon.propTypes;
ZoomIcon.renderIcon = (props) => <ZoomIcon {...props} />;
export default ZoomIcon;
